import React from 'react'

function Svg7(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 5h20.33"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.852 5v-.5a.5.5 0 00-.5.5h.5zm16.625 0h.5a.5.5 0 00-.5-.5V5zM3.852 13.165h-.5a.5.5 0 00.593.49l-.093-.49zm8.434 3.164l-.394.309a.5.5 0 00.787 0l-.393-.309zm8.191-3.207l-.079.494a.5.5 0 00.58-.494h-.5zM3.852 5.5h16.625v-1H3.852v1zm.5 7.665V5h-1v8.165h1zm-.407.49a8.2 8.2 0 011.527-.142v-1c-.585 0-1.158.055-1.713.16l.186.983zm1.527-.142a8.142 8.142 0 016.42 3.125l.787-.618a9.142 9.142 0 00-7.207-3.507v1zm7.207 3.125a8.142 8.142 0 016.42-3.125v-1a9.142 9.142 0 00-7.207 3.507l.787.618zm6.42-3.125c.443 0 .877.036 1.3.103l.157-.987a9.223 9.223 0 00-1.457-.116v1zM19.977 5v8.122h1V5h-1z"
        fill="currentColor"
      />
      <path d="M18.218 5v10.52" stroke="currentColor" />
      <circle cx={18.219} cy={17.428} stroke="currentColor" r={2.035} />
    </svg>
  )
}

export default Svg7
